import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const clearPettyCashCommonRequest = createAsyncThunk(
	"clearPettyCashCommonRequest",
	async ({ id }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`petty-cash/common-request/${id}/clear`);
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	}
);

const PettyCashCommonRequestClearSlice = createSlice({
	name: "PettyCashCommonRequestClearSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetPettyCashCommonRequestClearState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(clearPettyCashCommonRequest.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(clearPettyCashCommonRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(clearPettyCashCommonRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashCommonRequestClearState } = PettyCashCommonRequestClearSlice.actions;
export default PettyCashCommonRequestClearSlice.reducer;
